/**
	 * 
	 * @param {string} workItem - The key to find the correct lookup.
	 * @param {string} lookup - The value the client needs an alternative to.
	 * @returns {*} The value the client wants from the lookups in their configuration file.
	 * 
	 * If the slug is 'layoutType' and the value is 'desktop' then return 'client-desktop'
		lookups: {
			layoutType: {
				desktop: 'client-desktop',
				mobile: 'client-mobile'
			}
		}
	 */
const handleLookups = (workItem, lookup, lookups) => {
	return lookups[workItem][lookup];
};

export default handleLookups;
